import React from 'react';
import Modal from '@material-ui/core/Modal';
import CloseIcon from '@material-ui/icons/Close';

import { ModalWrapper, CloseButton, ModalDescription, StyledLink, LoginTitle } from './styles';

export function ModalExpired({ handleClose }) {
  return (
    <Modal
      open
      onClose={handleClose}
      aria-labelledby="simple-modal-title"
      aria-describedby="simple-modal-description"
      disableBackdropClick
    >
      <ModalWrapper>
        <CloseButton onClick={handleClose}>
          <CloseIcon />
        </CloseButton>
        <LoginTitle className="mb-3">
          Sua senha expirou!
        </LoginTitle>        
        <ModalDescription id="simple-modal-description">
          Para a Ultragaz a Segurança sempre vem em primeiro lugar! Clique abaixo para redefinir sua senha: <br/>
          <StyledLink href="/recuperar-senha">
            Clique aqui.
          </StyledLink>
        </ModalDescription>
      </ModalWrapper>
    </Modal>
  );
}
